import React, { useState } from 'react';
import { Modal, Form, Select, Button } from 'antd';

export default function TargetingAddToAudience({
  isOpen,
  onCancel,
  onSubmit,
  selectedLocations,
  targetingAudiences,
}) {
  const [form] = Form.useForm();

  const handleCancel = () => {
    form.resetFields();
    onCancel();
  };

  const handleOk = async () => {
    try {
      const values = await form.validateFields();
      await onSubmit(values.audienceId);
      form.resetFields();
    } catch (error) {
      console.error('Form validation failed:', error);
    }
  };

  return (
    <Modal
      title="Add to Existing Targeting Audience"
      visible={isOpen}
      onCancel={handleCancel}
      footer={null}
      width={500}
    >
      <Form form={form} layout="vertical" onFinish={handleOk} initialValues={{ audienceId: '' }}>
        <p style={{ marginBottom: '16px' }}>
          Select an existing Targeting Audience to add {selectedLocations.length} selected location
          {selectedLocations.length > 1 ? 's' : ''}:
        </p>

        <Form.Item
          label="Targeting Audience"
          name="audienceId"
          rules={[
            {
              required: true,
              message: 'Please select a Targeting Audience',
            },
          ]}
        >
          <Select
            placeholder="Select an existing Targeting Audience"
            showSearch
            filterOption={(input, option) =>
              option.children.toLowerCase().includes(input.toLowerCase())
            }
          >
            {targetingAudiences && targetingAudiences.length > 0 ? (
              targetingAudiences.map((audience) => (
                <Select.Option key={audience.id} value={audience.id}>
                  {audience.name}
                </Select.Option>
              ))
            ) : (
              <Select.Option disabled value="">
                No Targeting Audiences available
              </Select.Option>
            )}
          </Select>
        </Form.Item>

        <Form.Item style={{ marginBottom: 0, textAlign: 'right' }}>
          <Button type="default" onClick={handleCancel} style={{ marginRight: '8px' }}>
            Cancel
          </Button>
          <Button type="primary" htmlType="submit">
            Add to Targeting Audience
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
}
